'use strict';

/*
DOCUMENT ME
*/

define('modules/module.fad.static',['jquery', './module', 'txt!./module.fad.static.hbs', 'zipTools', 'lib/util/zip', 'storageUtil', 'lib/util/map.static'], function ($, Module, txtTemplate, zipTools, zip, storageUtil, mapStatic) {

  var FadModule = Module.extend({
    template: Handlebars.compile(txtTemplate),
    events: {
      'click .icon-crosshair': 'onLocateClicked',
      'click .icon-search-2': 'onSearchClicked'
    },
    staticData: {
      all: {
        subtextIcon: '/assets/img/module/fad/map.svg'
      },
      en: {
        subtext: 'Toyota Dealerships',
        headline: {
          '1x1': 'Find a Toyota Dealer',
          '2x1': 'Find a Toyota Dealer',
          '3x1': 'Find a Toyota Dealer',
        },
        copy: {
          '1x1': '<p>Looking to buy a Toyota? Browse Toyota cars for sale, from new car deals to used trucks.</p>',
          '2x1': '<p>Looking to buy a Toyota? Browse Toyota cars for sale, from new car deals to used trucks.</p>',
          '3x1': '<p>Looking to buy a Toyota? Browse Toyota cars for sale, from new car deals to used trucks.</p>',
        },
        actions:{
          title: 'Enter ZIP code'
        },
        // ghetto dataLayer arr, slightly different for each icon in the tmpl
        dataLayer: [
          {
            'link_text': 'geolocate'
          },
          {
            'link_text': 'Find a Toyota Dealer'
          }
        ]
      },
      es: {
        subtext: 'Concesionarios Toyota ',
        headline: {
          '1x1': 'Encuentra un concesionario Toyota',
          '2x1': 'Encuentra un concesionario Toyota',
          '3x1': 'Encuentra un concesionario Toyota',
        },
        copy: {
          '1x1': '<p>¿Quieres un Toyota? Explora las ofertas de los vehículos Toyota nuevos y usados.</p>',
          '2x1': '<p>¿Quieres un Toyota? Explora las ofertas de los vehículos Toyota nuevos y usados.</p>',
          '3x1': '<p>¿Quieres un Toyota? Explora las ofertas de los vehículos Toyota nuevos y usados.</p>',
        },
        actions: {
          title: 'Código postal'
        },
        dataLayer: [
          {
            'link_text': 'geolocate'
          },
          {
            'link_text': 'Encuentra un concesionario Toyota'
          }
        ]
      }
    },

    getTemplateContext: function () {
      return $.extend({}, this.staticData.all, this.staticData[this.getCanvas().getLang()], this.getConfig().data);
    },

    onLocateClicked: function () {
      var that = this;
      var success = function (newZip) {
        that.$el.find('input').val(newZip);
      };
      zipTools.geoLocationZip.detect(success, zipTools.reLoadDealerSearchWithoutZip);
    },

    onSearchClicked: function (e) {
      var newZip = this.$el.find('input').val();
      var dealerPath = zipTools.getSiteHomePath() + 'dealers/';
      var finalCb = function () { window.location.href = dealerPath; };
      if (newZip) {
        // update current target dataLayer
        var curTarget = $(e.currentTarget);
        var curDatalayer = curTarget.data('layer');
        var updatedDataLayer = $.extend(curDatalayer, { 'dealer_search_term': newZip, 'link_href': dealerPath });
        curTarget.data('layer', updatedDataLayer);
        zipTools.changeZip(storageUtil.getZip(), newZip, dealerPath, finalCb, true, false, false);
      }
    },

    onrender: function () {
      var currentZip;
      var zoomLevel;
      if (storageUtil.isConfirmedZip()) {
        currentZip = zip.getCookiedDefaultFallback();
        zoomLevel = 11;
        this.$el.find('input').val(currentZip);
      } else {
        currentZip = 'USA';
        zoomLevel = 5;
      }
      var $mapDom = this.$el.find('.module-front');
      mapStatic({ location: currentZip, size: '940x375', zoom: zoomLevel }).then(function (res) {
        $mapDom.css({
          'background-image': 'url(' + res + ')'
        });
      });
    }

  }, {
    configurable: false,
  });

  return FadModule;
});

